import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-row align-items-center" }
const _hoisted_2 = { class: "flex-column me-2" }
const _hoisted_3 = { class: "mt-15 mt-md-0" }
const _hoisted_4 = { class: "pagination mb-0" }
const _hoisted_5 = { class: "page-item" }
const _hoisted_6 = { class: "page-item" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "btn btn-sm btn-primary text-nowrap" }
const _hoisted_9 = { class: "page-item" }
const _hoisted_10 = { class: "page-item" }
const _hoisted_11 = { class: "flex-column" }
const _hoisted_12 = ["value"]

import { reactive, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    paginaAtual: { type: Number, required: true, default: 1 },
    tamanhoPagina: { type: Number, required: true, default: 20 },
    totalRegistros: { type: Number, required: true, default: 20 },
},
  emits: {
    onChange: null
},
  setup(__props, { emit: __emit }) {


var props = __props;

var emit = __emit;

var controle = reactive({
    paginaAtual: props.paginaAtual,
    tamanhoPagina: props.tamanhoPagina,
    totalRegistros: props.totalRegistros,
    paginaFinal: Math.ceil(props.totalRegistros / props.tamanhoPagina) ?? 1,
    tamanhosPaginas: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 1000, 2000, 3000, 4000, 5000, 10000]
})

watch(() => props.paginaAtual, (novo: any) => {
    // console.log("Alterou pagina atual")
    controle.paginaAtual = novo;
    recalcular();
});

watch(() => props.tamanhoPagina, async (novo: any, antigo: any) => {
    // console.log("Alterou tamanho pagina")
    controle.tamanhoPagina = novo;
    recalcular();
});

watch(() => props.totalRegistros, async (novo: any, antigo: any) => {
    controle.totalRegistros = novo;
    recalcular();
});

const selecionarPagina = (pagina: number) => {
    if (controle.paginaAtual != pagina) {

        controle.paginaAtual = pagina;
        if (controle.paginaAtual <= 0)
            controle.paginaAtual = 1;

        if (controle.paginaAtual > controle.paginaFinal)
            controle.paginaAtual = controle.paginaFinal;

        change();
    }
};

const selecionarTamanho = (e: any) => {
    var tamanho = 0
    if (e) tamanho = e.target.value
    controle.tamanhoPagina = Number(tamanho);
    controle.paginaAtual = 1;

    change();
}

const recalcular = () => {
    controle.paginaFinal = Math.ceil(controle.totalRegistros / controle.tamanhoPagina);
}

const change = () => {

    var el = {
        tamanhoPagina: Number(controle.tamanhoPagina),
        paginaAtual: controle.paginaAtual,
    }
    console.log("paginador on change", el);
    emit("onChange", el);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (selecionarPagina(1)))
            }, " «« ")
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (selecionarPagina(_unref(controle).paginaAtual - 1)))
            }, " « ")
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(controle).paginaAtual) + " de" + _toDisplayString(_unref(controle).paginaFinal), 1)
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (selecionarPagina(_unref(controle).paginaAtual + 1)))
            }, " » ")
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (selecionarPagina(_unref(controle).paginaFinal)))
            }, " »» ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("select", {
        class: "p-2 form-select rounded-1 text-primary",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).tamanhoPagina) = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (selecionarTamanho($event)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).tamanhosPaginas, (item, idx) => {
          return (_openBlock(), _createElementBlock("option", {
            value: item,
            key: idx
          }, _toDisplayString(item) + " registros ", 9, _hoisted_12))
        }), 128))
      ], 544), [
        [_vModelSelect, _unref(controle).tamanhoPagina]
      ])
    ])
  ]))
}
}

})